<script setup lang="ts">
import { computed } from 'vue';

type AlertType = 'info';

const props = withDefaults(
    defineProps<{
        type?: AlertType;
        text: string;
    }>(),
    { type: 'info' }
);

const alert = computed(() => {
    const temp = {
        class: '',
        icon: [] as string[]
    };
    switch (props.type) {
        case 'info':
            temp.class = 'bg-gray-lightest border-gray-light';
            temp.icon = ['fa-solid', 'fa-circle-info'];
            break;
    }
    return temp;
});
</script>

<template>
    <div class="c-alert-wrapper" :class="alert.class">
        <template v-if="!$slots.default">
            <font-awesome-icon v-if="alert.icon.length" :icon="alert.icon" class="mr-2" />
            {{ text }}
        </template>
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.c-alert-wrapper {
    padding: 0.625rem 0.75rem;
    border-radius: 0.5rem;
}
</style>
